// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"888":"51f62e51db346fe4","890":"7965df74a192a5d3"}[chunkId] + ".css";
};